import BaladIcon from "@/app/icons/baladIcon";
import GoogleMapIcon from "@/app/icons/googleMapIcon";
import NeshanIcon from "@/app/icons/neshanIcon";
import WazeIcon from "@/app/icons/wazeIcon";

import { AppConnectionType } from "./types";

export const appConnection: AppConnectionType[] = [
  {
    id: 0,
    title: "مسیریابی بلد",
    icon: BaladIcon,
    type: "balad",
  },
  {
    id: 1,
    title: "مسیریابی map",
    icon: GoogleMapIcon,
    type: "google",
  },
  {
    id: 2,
    title: "مسیریابی Waze",
    icon: WazeIcon,
    type: "waze",
  },
  {
    id: 3,
    title: "مسیریابی نشان",
    icon: NeshanIcon,
    type: "neshan",
  },
];
